export interface IQuery { }

export class PeopleByRegionQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.RankHR.People.Queries.PeopleByRegionQueryV1, TCh.Domain.RankHR'

	RegionId: string
	OnlyEnabled: boolean

	constructor (regionId: string, onlyEnabled: boolean)
	{
		this.RegionId = regionId
		this.OnlyEnabled = onlyEnabled
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.RankHR.People.Queries.PeopleByRegionQueryV1, TCh.Domain.RankHR'
	}

}

export class PersonVotesQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.RankHR.People.Queries.PersonVotesQueryV1, TCh.Domain.RankHR'

	PersonId: string

	constructor (personId: string)
	{
		this.PersonId = personId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.RankHR.People.Queries.PersonVotesQueryV1, TCh.Domain.RankHR'
	}

}

